import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "menuButton", "menu", "navbar", "wrapper" ]
  static values = { navbarColored: Boolean, menuShow: Boolean }

  async connect() {
    const dummy = document.querySelector('#dummy')
    if (dummy) {
      let callback = (entries, observer) => {
        const entry = entries[0]
        const element = document.querySelector('#header')
        if (entry.isIntersecting) {
          element.classList.remove('navbar-colored')
        } else {
          element.classList.add('navbar-colored')
        }
      }
      this.observer = new IntersectionObserver(callback, { threshold: 1.0 })
      this.observer.observe(dummy)
    }

    this.resizeHandler = () => {
      if (this.hasWrapperTarget) {
        this.wrapperTarget.style.paddingBottom = `${this.navbarTarget.offsetHeight}px`
      }
    }
    this.resizeHandler()
    window.addEventListener('resize', this.resizeHandler)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener('resize', this.resizeHandler)
  }

  showMenu(event) {
    event.preventDefault()
    this.menuShowValue = true
  }

  hideMenu(event) {
    event.preventDefault()
    this.menuShowValue = false
  }

  toggleMenu(event) {
    event.preventDefault()
    this.menuShowValue = !this.menuShowValue
  }

  menuShowValueChanged() {
    if (this.menuShowValue) {
      this.menuTarget.classList.remove('invisible')
      this.navbarTarget.classList.add('navbar-colored-menu')
    } else {
      this.menuTarget.classList.add('invisible')
      this.navbarTarget.classList.remove('navbar-colored-menu')
    }
  }

  navbarColoredValueChanged() {
    if (this.navbarColoredValue) {
      this.navbarTarget.classList.remove('navbar-colored')
    } else {
      this.navbarTarget.classList.add('navbar-colored')
    }
  }
}
